import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Constants } from "src/Constants";
import { IconItem } from "src/pages/dynamicPages/agent";
import { imageUpload } from "src/services/BannersServices";

type Direction = {
  id?: number;
  nombre: string;
  direccion: string;
  telefono: string;
  horario: string;
  imagen: string;
  email: string;
  lat: string;
  lng: string;
};

interface Props {
  d?: Direction;
  fetch: any;
  setAddNew?: any;
}

const instance = axios.create({ baseURL: Constants.BASE_URL });

export default function Direction({ d, fetch, setAddNew }: Props) {
  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [horario, setHorario] = useState("");
  const [email, setEmail] = useState("");
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [img, setImg] = useState("");

  useEffect(() => {
    if (d?.id) {
      setNombre(d.nombre);
      setDireccion(d.direccion);
      setTelefono(d.telefono);
      setHorario(d.horario);
      setEmail(d.email);
      setLat(d.lat);
      setLng(d.lng);
      setImg(d.imagen);
    }
  }, [d]);

  const deleteDirection = async () => {
    if (!window.confirm("Desea eliminar la sucursal?")) return;
    try {
      const httpOptions = {
        headers: {
          Authorization: "",
        },
      };

      if (d?.id) {
        await instance.delete(`/directions/${d?.id}`, httpOptions);
        toast(`Sucursal Eliminada con exito`, {
          position: toast.POSITION.BOTTOM_CENTER,
          pauseOnHover: false,
        });
        fetch();
      }
    } catch (error) {
      throw error;
    }
  };

  const saveDirection = async () => {
    try {
      const httpOptions = {
        headers: {
          Authorization: "",
        },
      };

      if (d?.id) {
        await instance.put(
          `/directions/${d?.id}`,
          {
            nombre,
            direccion,
            telefono,
            horario,
            email,
            img,
            lat,
            lng,
          },
          httpOptions
        );
        toast(`Sucursal actualizada con exito`, {
          position: toast.POSITION.BOTTOM_CENTER,
          pauseOnHover: false,
        });
      } else {
        await instance.post(
          `/directions`,
          {
            nombre,
            direccion,
            telefono,
            horario,
            email,
            img,
            lat,
            lng,
          },
          httpOptions
        );

        toast(`Sucursal agregada con exito`, {
          position: toast.POSITION.BOTTOM_CENTER,
          pauseOnHover: false,
        });
        setAddNew(false);
      }
      fetch();
    } catch (error) {
      throw error;
    }
  };

  const handleAcceptedFiles = async (files: any, key: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "contact_directions",
        });
        if (key === "image") {
          setImg(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  return (
    <div
      key={d?.id}
      className="row"
      style={{ margin: 20, height: "290px", marginBottom: 200 }}
    >
      <div
        className="col-12"
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
        }}
      >
        <div className="col-4" style={{ border: "1px solid #e7e7e7" }}>
          <div className="col-12">
            <IconItem
              icon={img}
              handleAcceptedFiles={handleAcceptedFiles}
              iconKey="image"
              ignoreLink={true}
            />
          </div>
        </div>
        <div
          className="col-4"
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            textAlign: "left",
            flexDirection: "column",
            padding: "0px 15px",
            border: "1px solid #e7e7e7",
          }}
        >
          <h3>
            <input
              placeholder="Nombre"
              style={{ width: "100%" }}
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </h3>
          <div
            className="item"
            style={{ display: "flex", alignItems: "start" }}
          >
            <input
              placeholder="Direccion"
              style={{ width: "100%" }}
              type="text"
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
            />
          </div>
          <div className="item">
            <span style={{ color: "#003399" }}>
              <input
                style={{ width: "100%" }}
                placeholder="Telefono"
                type="text"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
              />
            </span>
          </div>
          <div className="item">
            <span style={{ color: "#003399" }}>
              <input
                style={{ width: "100%" }}
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </span>
          </div>
          <div className="item" style={{ fontSize: 15 }}>
            <small>
              Horario:{" "}
              <textarea
                value={horario}
                placeholder="Horario"
                style={{ width: "100%" }}
                rows={2}
                onChange={(e) => setHorario(e.target.value)}
              ></textarea>
            </small>
          </div>
        </div>
        <div
          className="col-4"
          style={{
            border: "1px solid #e7e7e7",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label>Latitud</label>
          <input
            placeholder="Latitud"
            style={{ width: "100%" }}
            type="text"
            value={lat}
            onChange={(e) => setLat(e.target.value)}
          />
          <label>Longitud</label>
          <input
            placeholder="Longitud"
            style={{ width: "100%" }}
            type="text"
            value={lng}
            onChange={(e) => setLng(e.target.value)}
          />
        </div>
      </div>
      <button
        className="btn btn-primary waves-effect waves-light"
        onClick={() => saveDirection()}
        style={{ margin: "10px 5px 0px 5px", width: "200px", marginLeft: 'auto' }}
      >
        Guardar
      </button>
      {d?.id ? (
        <button
          className="btn btn-danger waves-effect waves-light"
          onClick={() => deleteDirection()}
          style={{ margin: "10px 5px 0px 5px", width: "200px" }}
        >
          Eliminar
        </button>
      ) : (
        <button
          className="btn btn-primary waves-effect waves-light"
          onClick={() => setAddNew(false)}
          style={{ margin: "10px 5px 0px 5px", width: "200px" }}
        >
          Cancelar
        </button>
      )}
    </div>
  );
}
